import { TranslatedValidationError } from 'models/formError';
import { createContext, useContext } from 'react';

export type CurrencyPairSwitcherContextProps = {
  id: string;
  switchedCurrencyTranslationKey: string;
  isLabelHidden?: boolean;
  value: Nullable<string>;
  onToggleCurrency: (newCurrency: string) => void;
  currency1: string;
  currency2: string;
  tabIndex?: number;
  validationError?: TranslatedValidationError;
};

export const CurrencyPairSwitcherContext = createContext<CurrencyPairSwitcherContextProps | undefined>(undefined);

export function useCurrencyPairSwitcherContext() {
  const context = useContext(CurrencyPairSwitcherContext);
  if (!context) {
    throw new Error('CurrencyPairSwitcher subcomponents must be used within CurrencyPairSwitcher');
  }
  return context;
}
